import { render, staticRenderFns } from "./orange.vue?vue&type=template&id=8c28aa48&scoped=true"
import script from "./orange.vue?vue&type=script&lang=js"
export * from "./orange.vue?vue&type=script&lang=js"
import style0 from "./orange.vue?vue&type=style&index=0&id=8c28aa48&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c28aa48",
  null
  
)

export default component.exports